import { TravelCategoryEnum } from '@insurance/api/requests'
import { RadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { SportCategorySelect } from './SportCategorySelect'

export const PurposeOfTrip = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const travelCategory = Form.useWatch('travel_category')

  const isSportCompetitions =
    travelCategory === TravelCategoryEnum.SPORT_COMPETITIONS

  return (
    <>
      <Form.Item
        name="travel_category"
        label={t('purpose_of_the_trip')}
        rules={[required]}
      >
        <RadioCardGroup
          options={Object.values(TravelCategoryEnum).map((value) => ({
            value,
            label: t(value),
            colProps: { xs: 24, lg: 12 }
          }))}
        />
      </Form.Item>

      {isSportCompetitions && <SportCategorySelect />}
    </>
  )
}
